<template>
  <div
    v-if="panel"
    class="playlist-layer smart-panel"
    :data-test="`panel:${panel._id}`"
    :class="[{'is-video': hasPlayButton } , { 'editing': isEditing }]"
    @click="onClickTimelineItem"
  >
    <div class="layer-info">
      <button class="drag-handle tb-btn tb-btn-link sm low-em" title="Rearrange"><span class="icon icon-drag-handle"></span></button>

      <div class="layer-title flex-grow margin-left-xs">
        <img
          v-if="settings.backgroundImage"
          class="layer-preview margin-right-xs"
          :src="settings.backgroundImage"
          alt=""
        >

        <div class="flex-grow ellipsis">
          <div class="title-text">{{ item.title || panel.title }}</div>
          <div class="description-text capitalize">{{displayTitle}}</div>
        </div>
      </div>

      <div class="layer-description capitalize margin-left-xxs">
        <duration
          v-if="!hasPlayButton"
          :duration.sync="item.displayTime"
          class="margin-left-xxs"
        />

        <template v-else>
          <button v-if="videoPlaying" class="tb-btn tb-btn-contained sm medium-em margin-left-xxs margin-right-md pause-panel" v-on:click.stop.prevent="pauseVideo"><span class="icon icon-pause"></span></button>
          <button v-else class="tb-btn tb-btn-contained sm medium-em margin-left-xxs margin-right-md play-panel" v-on:click.stop.prevent="playVideo"><span class="icon icon-play"></span></button>
        </template>
      </div>

      <preview-live-switch :item='item' />

      <dropdown position="left" class="more-actions margin-left-xxs">
        <template slot="trigger"><button class="tb-btn tb-btn-text sm medium-em" title="More actions"><span class="icon icon-more-vertical"></span></button></template>

        <template slot="dropdown-body">
          <button
            class="dropdown-list-item"
            @click="removeItem"
          >
            <span class="dropdown-list-item-label warning">
              Remove
            </span>
          </button>
        </template>
      </dropdown>
    </div>
  </div>

  <!-- Loading State -->
  <!-- Shown if !panel, but panel store is loading something. -->
  <!-- Should update loading flags so we know WHAT is being loaded though -->
  <div
    v-else-if="isLoading"
    class="playlist-layer flex items-center"
    :class="{ active: (isCurrentLayout || isCurrentSampleLayout)}"
  >
    <div class="playlist-layer__skeleton" />

    <div class="layer-info">
      <button
        class="tb-btn tb-btn-text sm medium-em margin-left-xxs"
        title="Remove item from playlist"
        @click.stop.prevent="removeItem"
      >
        <i class="icon icon-minus-circle"></i>
      </button>
    </div>
  </div>

  <div
    v-else
    class="playlist-layer deleted"
    :class="{ active: (isCurrentLayout || isCurrentSampleLayout)}"
  >
    <div class="layer-info">
      <div class="deleted-message">This Panel has been deleted, or failed to load.</div>

      <button
        class="tb-btn tb-btn-text sm medium-em margin-left-xxs"
        title="Remove item from playlist"
        @click.stop.prevent="removeItem"
      >
        <i class="icon icon-minus-circle"></i>
      </button>
    </div>
  </div>
</template>

<script>
import DurationComponent from '../duration-input/DurationInput.vue';
import timelineMixins from '../../../mixins/timeline-mixins';
import PreviewLiveSwitch from '../../PreviewLiveSwitch.vue';

export default {
  name: 'TimelinePanelComponent',
  props: ['item'],
  mixins: [timelineMixins],

  components: {
    duration: DurationComponent,
    'preview-live-switch': PreviewLiveSwitch,
  },

  created() {
    window.addEventListener('message', this.onMessage, false);
  },

  beforeDestroy() {
    window.removeEventListener('message', this.onMessage);
  },

  methods: {
    onMessage(e) {
      if (e.origin !== process.env.TAGBOARD_PANELS_URL) {
        return;
      }

      if (typeof e.data === 'string' && e.data.indexOf('tgbSmartPanelUpdate') === 0) {
        const panel = JSON.parse(e.data.split('|')[1]);
        this.$store.commit('EDIT_PANEL', panel);
      }
    },
  },

  computed: {
    /**
     * Whether or not the `panels` store module is loading data.
     */
    isLoading() {
      return this.$store.state.panels.isLoading;
    },

    panel() {
      return this.$store.state.panels.lookupTable[this.item._id];
    },

    settings() {
      return this.panel?.settings || {};
    },

    hasPlayButton() {
      return this.item.type === 'timer' || this.item.type === 'vimeo' || this.item.type === 'youtube';
    },

    owner() {
      return this.$store.state.production.production.owner;
    },
  },
};
</script>
